
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/detail",
      function () {
        return require("private-next-pages/pricing/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/detail"])
      });
    }
  